import React from "react";
import styled from "styled-components";

// Hvata neuhvaćene greške u renderu da aplikacija ne završi na praznom
// belom ekranu (React bez boundary-ja demontira celo stablo). Umesto toga
// korisnik dobija poruku i dugme za osvežavanje.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary uhvatio grešku:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <Content>
            <h2>Došlo je do greške</h2>
            <p>
              Nešto je pošlo po zlu pri prikazu stranice. Osvežite stranicu i
              pokušajte ponovo — ako koristite automatski prevod stranice
              (Google Translate), isključite ga jer može da poremeti rad sajta.
            </p>
            <ReloadButton onClick={this.handleReload}>
              Osveži stranicu
            </ReloadButton>
          </Content>
        </Container>
      );
    }

    return this.props.children;
  }
}

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: #faf7f5;
`;

const Content = styled.div`
  text-align: center;
  max-width: 420px;

  h2 {
    color: #333;
    margin-bottom: 12px;
  }

  p {
    color: #666;
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 24px;
  }
`;

const ReloadButton = styled.button`
  background: #7a1f3d;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 28px;
  font-size: 15px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export default ErrorBoundary;
